import ANALYTICS_FILTERS from 'app/constants/analyticsConstants';
import copy from 'copy-to-clipboard';

export const getCountryFullNameWithCode = (countryCode) => {
    const country = ANALYTICS_FILTERS.COUNTRY_CODES.find((country) => {
        return country.code === countryCode;
    });
    return country ? country.label : countryCode;
};

export const capitalizeFirst = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};


export const copyContent = (content, setCopied) => {
    copy(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
};

// Web-chat accounts are keyed by domain + optional sub-path (e.g. two rows can
// both be "uatlink.com" with paths "/intell/" and "/other/" as independent
// channels) - always display both so same-domain rows are distinguishable.
export const formatWebAccountLabel = account => {
    if (!account) return '';
    const path = account.path;
    return path && path !== '/' ? `${account.domain}${path}` : account.domain || '';
};